// extracted by css-extract-rspack-plugin
export default {"tableDrag":"roadmap-table-drag-sash-module__tableDrag__s6SsY","tableHeaderDrag":"roadmap-table-drag-sash-module__tableHeaderDrag__swZR1"};